"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { SkuTranslator } from "@sticker-giant/sg-frontend-common";
import { IconLoader2 } from "@tabler/icons-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { trackQuantitySelected } from "@/lib/analytics/segment";
import { isFinishedGood } from "@/lib/cart-item-utils";
import { useQuantitiesForItem } from "@/queries/useQuantitiesForItem";
interface Props {
  item: CartItemOutputDto;
  onQuantityChange: (quantity: number) => void;
  onCustomSelected: () => void;
  isCustomSelected: boolean;
}
export function QuantitySelect(t0) {
  const $ = _c(32);
  const {
    item,
    onQuantityChange,
    onCustomSelected,
    isCustomSelected
  } = t0;
  const {
    quantities,
    presetQuantities,
    isLoading
  } = useQuantitiesForItem(item);
  let t1;
  if ($[0] !== item.sku.product) {
    t1 = SkuTranslator.getProductCategory(item.sku.product);
    $[0] = item.sku.product;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const productCategory = t1;
  let t2;
  if ($[2] !== item.quantity || $[3] !== presetQuantities || $[4] !== quantities) {
    t2 = quantities && !presetQuantities?.includes(item.quantity) && quantities.allowCustomQuantity;
    $[2] = item.quantity;
    $[3] = presetQuantities;
    $[4] = quantities;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isCustomQuantityApplied = t2;
  let t3;
  if ($[6] !== item || $[7] !== productCategory) {
    t3 = function formatQuantityLabel(quantity) {
      const label = quantity.toLocaleString();
      return isFinishedGood(item) ? label : `${label} ${productCategory}`;
    };
    $[6] = item;
    $[7] = productCategory;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const formatQuantityLabel = t3;
  let t4;
  if ($[9] !== onCustomSelected || $[10] !== onQuantityChange) {
    t4 = function handleValueChange(selectedValue) {
      if (selectedValue === "custom") {
        onCustomSelected();
        trackQuantitySelected("custom", "cart");
        return;
      }
      onQuantityChange(Number(selectedValue));
      trackQuantitySelected(Number(selectedValue), "cart");
    };
    $[9] = onCustomSelected;
    $[10] = onQuantityChange;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleValueChange = t4;
  if (isLoading) {
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex items-center justify-center py-2"><IconLoader2 className="animate-spin" /></div>;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  const t5 = isCustomSelected ? "custom" : String(item.quantity);
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SelectTrigger className="w-full"><SelectValue /></SelectTrigger>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== formatQuantityLabel || $[15] !== presetQuantities) {
    t7 = presetQuantities?.map(quantity_0 => <SelectItem key={quantity_0} value={String(quantity_0)}>{formatQuantityLabel(quantity_0)}</SelectItem>);
    $[14] = formatQuantityLabel;
    $[15] = presetQuantities;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== formatQuantityLabel || $[18] !== isCustomQuantityApplied || $[19] !== isCustomSelected || $[20] !== item.quantity) {
    t8 = isCustomQuantityApplied && !isCustomSelected && <SelectItem value={String(item.quantity)}>{formatQuantityLabel(item.quantity)}</SelectItem>;
    $[17] = formatQuantityLabel;
    $[18] = isCustomQuantityApplied;
    $[19] = isCustomSelected;
    $[20] = item.quantity;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== quantities?.allowCustomQuantity) {
    t9 = quantities?.allowCustomQuantity && <SelectItem value="custom">Custom Quantity</SelectItem>;
    $[22] = quantities?.allowCustomQuantity;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <SelectContent>{t7}{t8}{t9}</SelectContent>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== handleValueChange || $[29] !== t10 || $[30] !== t5) {
    t11 = <Select value={t5} onValueChange={handleValueChange}>{t6}{t10}</Select>;
    $[28] = handleValueChange;
    $[29] = t10;
    $[30] = t5;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}